import { CalendarDays, ChefHat, Home, Sparkles } from "lucide-react";
import type { ReactNode } from "react";
import { useCatalog } from "../hooks/useCatalog";
import { ServiceCard } from "../components/ServiceCard";
import { SectionHeader } from "../components/SectionHeader";

export function PrivateChefPage() {
  const { services } = useCatalog();

  return (
    <main className="page-shell">
      <section className="split-hero" id="in-home-dining">
        <div>
          <p className="eyebrow">Private chef experiences</p>
          <h1>Host beautifully. We handle the kitchen.</h1>
          <p>
            Chef OJ creates private dining, brunch tables, and cocktail nights with menus built
            around your people, your space, and the kind of night you want to remember.
          </p>
        </div>
        <img src="/assets/site/private-chef-plating.jpg" alt="Chef plating a private dinner" />
      </section>
      <section className="content-section compact-section" id="how-it-works">
        <SectionHeader title="How it works" centered />
        <div className="steps-grid">
          <Step icon={<CalendarDays />} title="Choose date" body="Send the event details and your ideal date." />
          <Step icon={<ChefHat />} title="Build menu" body="Chef OJ helps shape the menu around your guests." />
          <Step icon={<Home />} title="Host beautifully" body="We cook, plate, serve, and make the moment easy." />
          <Step icon={<Sparkles />} title="Enjoy the moment" body="You get the credit. We handle the heavy lifting." />
        </div>
      </section>
      <section className="content-section" id="book">
        <SectionHeader title="Book Your Experience" centered />
        <div className="service-grid">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </section>
    </main>
  );
}

function Step({ icon, title, body }: { icon: ReactNode; title: string; body: string }) {
  return (
    <article className="step-card">
      {icon}
      <h3>{title}</h3>
      <p>{body}</p>
    </article>
  );
}
